import { render, staticRenderFns } from "./DashboardFilterCustomSelect.vue?vue&type=template&id=04831afe&"
import script from "./DashboardFilterCustomSelect.vue?vue&type=script&lang=ts&"
export * from "./DashboardFilterCustomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardFilterCustomSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports